import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left industry-usecase-title" mdxType="TitleBlock" />
    <h2 {...{
      "id": "explore-use-cases"
    }}>{`Explore use cases`}</h2>
    <ResourceCard slots="image, heading, text" width="25%" theme='light' className="useCaseCard-seal-api Get-started-in-minutes" mdxType="ResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "482px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.18749999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a89b92a5c251bc73df788de831e44c1e/5530d/Invoices.webp 320w", "/document-services/static/a89b92a5c251bc73df788de831e44c1e/82cab/Invoices.webp 482w"],
            "sizes": "(max-width: 482px) 100vw, 482px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a89b92a5c251bc73df788de831e44c1e/8980b/Invoices.jpg 320w", "/document-services/static/a89b92a5c251bc73df788de831e44c1e/6bf2f/Invoices.jpg 482w"],
            "sizes": "(max-width: 482px) 100vw, 482px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/a89b92a5c251bc73df788de831e44c1e/6bf2f/Invoices.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "bills--invoices"
    }}>{`Bills & Invoices`}</h2>
    <p>{`Maintain credibility of bills and invoices by applying an e-seal to help avoid any tax implications from erroneous accounting information
or tampering after the e-seal was applied.`}</p>
    <ResourceCard slots="image, heading, text" width="25%" theme='light' className="useCaseCard-seal-api Get-started-in-minutes" mdxType="ResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "482px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.18749999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a51a84bbde61e8e5ad70c15bf37ae2ad/5530d/HR.webp 320w", "/document-services/static/a51a84bbde61e8e5ad70c15bf37ae2ad/82cab/HR.webp 482w"],
            "sizes": "(max-width: 482px) 100vw, 482px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a51a84bbde61e8e5ad70c15bf37ae2ad/8980b/HR.jpg 320w", "/document-services/static/a51a84bbde61e8e5ad70c15bf37ae2ad/6bf2f/HR.jpg 482w"],
            "sizes": "(max-width: 482px) 100vw, 482px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/a51a84bbde61e8e5ad70c15bf37ae2ad/6bf2f/HR.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "hr-documents"
    }}>{`HR Documents`}</h3>
    <p>{`E-seal critical documents such as employment verification letters, travel documents, proof of employment, job offers, etc.`}</p>
    <ResourceCard slots="image, heading, text" width="25%" theme='light' className="useCaseCard-seal-api Get-started-in-minutes" mdxType="ResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "482px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.18749999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/7283f1c1261ef5bb46f2a9713a576ac5/5530d/Education.webp 320w", "/document-services/static/7283f1c1261ef5bb46f2a9713a576ac5/82cab/Education.webp 482w"],
            "sizes": "(max-width: 482px) 100vw, 482px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/7283f1c1261ef5bb46f2a9713a576ac5/8980b/Education.jpg 320w", "/document-services/static/7283f1c1261ef5bb46f2a9713a576ac5/6bf2f/Education.jpg 482w"],
            "sizes": "(max-width: 482px) 100vw, 482px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/7283f1c1261ef5bb46f2a9713a576ac5/6bf2f/Education.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "education"
    }}>{`Education`}</h3>
    <p>{`E-seal transcripts, degree and scholarship certificates, and other educational documents.`}</p>
    <ResourceCard slots="image, heading, text" width="25%" theme='light' className="useCaseCard-seal-api Get-started-in-minutes" mdxType="ResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "482px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.18749999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/856af6e4c135481032312950c4df34b4/5530d/Reports.webp 320w", "/document-services/static/856af6e4c135481032312950c4df34b4/82cab/Reports.webp 482w"],
            "sizes": "(max-width: 482px) 100vw, 482px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/856af6e4c135481032312950c4df34b4/8980b/Reports.jpg 320w", "/document-services/static/856af6e4c135481032312950c4df34b4/6bf2f/Reports.jpg 482w"],
            "sizes": "(max-width: 482px) 100vw, 482px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/856af6e4c135481032312950c4df34b4/6bf2f/Reports.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "technical-reports"
    }}>{`Technical Reports`}</h3>
    <p>{`Detect tampering of technical report on research studies or market analysis before distribution or archival.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      